/**
 * Whether the UI may animate (D-6).
 *
 * Shared by the gesture surfaces — Horizon's sheet and the Ledger's period
 * swipe. `src/water/` deliberately keeps its own check: everything in D-4/D-5/D-6
 * for the shader lives there and nowhere else (PROJECT_STRUCTURE), so this is
 * not a single global policy point and should not claim to be.
 *
 * Read live rather than cached: the preference can change while the app is open,
 * and this is checked inside pointer handlers where a stale answer would mean a
 * drag that follows the finger for a user who asked it not to.
 */
export function prefersReducedMotion(): boolean {
  return typeof window.matchMedia === "function" && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
}
